/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */

import { Button, Column, ContentSection, Label, Modal, ModalTitle, TitleSection } from "trux"
import { useHistory } from "react-router"
import "./NotAllowedDialog.css"
import React from "react"

export const NotAllowedDialog = (props) => {
    const history = useHistory()

    return (
        <Modal
            open={true}
            onShadeClick={() => {
                history.goBack()
            }}
            trkContext="Not Allowed Dialog"
            className="NotAllowedDialog"
        >
            <TitleSection
                onCloseClick={() => {
                    history.goBack()
                }}
            >
                <ModalTitle content="Not allowed" />
            </TitleSection>
            <ContentSection>
                <Column alignItems="center">
                    <img className="sad-tracebot" src="clips/images/sad_tracebot.svg" alt="Sad Tracebot" />
                    <Label
                        className="permission-label"
                        type={Label.Type.Body}
                        content="You don’t have permission to do that on this team. Please contact your team owner or manager to get access."
                        marginTop="8"
                        marginBottom="8"
                        center
                    />
                    <Button
                        className="ok-button"
                        marginBottom="2"
                        height={56}
                        primary
                        content="OK"
                        trkAction="Ok Button Pressed"
                        onClick={() => history.goBack()}
                    />
                </Column>
            </ContentSection>
        </Modal>
    )
}
